import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19c-2.209 0-4-1.791-4-4 0-1.6808 1.03688-3.1196 2.50583-3.7116C4.50196 11.1928 4.5 11.0966 4.5 11c0-3.866 3.134-7 7-7 2.8636 0 5.3256 1.71948 6.4098 4.18228C20.2645 8.8047 22 10.9493 22 13.5c0 3.038-2.462 5.5-5.5 5.5-.1685 0-.3353-.0076-.5-.0224V19H6zm2-7l4 4 4-4h-2V9h-4v3H8z",
    fill: "currentColor"
  }));
});